<!-- @TODO: Ignored manually on 2023-10-13 -->
<!-- eslint-disable @angular-eslint/template/use-track-by-function -->
@for (group of menuGroup | async; track group) {
    <div class="mf-menu-group pb-2">
        <!-- eslint-enable -->
        <div class="text-uppercase mf-menu-group_title">
            <span class="mf-menu-group_title_text pl-2 font-weight-bold">
                {{ group.groupTitle }}
            </span>
        </div>
        <!-- @TODO: Ignored manually on 2023-10-13 -->
        <!-- eslint-disable @angular-eslint/template/use-track-by-function -->
        @for (menu of group.menu; track menu) {
            <div class="mf-menu">
                <!-- eslint-enable -->
                <a
                    [routerLink]="menu.link"
                    [queryParams]="menu.queryParams"
                    [ngbTooltip]="menu.title"
                    [disableTooltip]="!isMin()"
                    [routerLinkActiveOptions]="{ exact: false }"
                    tooltipClass="mf-tooltip"
                    placement="right"
                    container="body"
                    routerLinkActive="mf-menu_item--active"
                    class="mf-menu_item"
                >
                    @if (isMin()) {
                        <i class="pr-1" [ngClass]="menu.icon"></i>
                    }
                    <span class="mf-menu_item_text">{{ menu.title }}</span>
                    @if (!isMin()) {
                        @if (menu.wip) {
                            <i ngbTooltip="V razvoju" class="pl-1 las la-hourglass-half text-info"></i>
                        }
                        @if (menu.premium) {
                            <i ngbTooltip="Zaklenjeno" class="pl-1 las la-gem text-brand"></i>
                        }
                    }
                </a>
            </div>
        }
    </div>
}
